// extracted by mini-css-extract-plugin
export default {"survey_title":"index_survey_title_2bZ-- clearfix","count_box":"index_count_box_VrlBT","count":"index_count_6-Q1s","logo":"index_logo_dc8-b","img":"index_img_IB7zR"};